import { useAuthenticationContext } from 'context/AuthenticationContext'

function useIsLoggedIn() {
  const { isLoggedIn } = useAuthenticationContext()
  return isLoggedIn
}

export default useIsLoggedIn
